import { DateTime } from 'luxon';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ExportInterfaceAllSourceFieldsDTO, ExportInterfaceConfigurationClient, ExportInterfaceConfigurationType, ExportInterfaceFieldAssignmentSourceInfoDTO, ExportInterfaceMasterDataDTO } from 'src/app/base/models/models.swagger.generated';

@Injectable({
  providedIn: 'root'
})
export class ExportConfigurationMasterDataServiceService {

  constructor(private exportInterfaceConfigurationClient: ExportInterfaceConfigurationClient) { }

  public loadSourceFields(): Observable<ExportInterfaceAllSourceFieldsDTO> {
    if (!this.allSourceFieldsDTO || !this.sourceFieldsLastLoadedTime || this.sourceFieldsLastLoadedTime.plus({ hours: ExportConfigurationMasterDataServiceService._EXPIRATION_IN_HOURS }).toMillis() < DateTime.now().toMillis()) {
      return this.exportInterfaceConfigurationClient.getAllSourceFields().pipe(
        tap((sourceFields: ExportInterfaceAllSourceFieldsDTO) => {
          this.allSourceFieldsDTO = sourceFields;
          this.sourceFieldsLastLoadedTime = DateTime.now();
        })
      );
    }
    return of(this.allSourceFieldsDTO);
  }

  private masterData: ExportInterfaceMasterDataDTO;
  private lastLoadedTime: DateTime;

  private static _EXPIRATION_IN_HOURS = 4;

  private allSourceFieldsDTO: ExportInterfaceAllSourceFieldsDTO;
  private sourceFieldsLastLoadedTime: DateTime;

  public getMasterDataForFileName(): Observable<ExportInterfaceMasterDataDTO> {
    if (!this.masterData || !this.lastLoadedTime || this.lastLoadedTime.plus({ hours: ExportConfigurationMasterDataServiceService._EXPIRATION_IN_HOURS }).toMillis() < DateTime.now().toMillis()) {
      return this.exportInterfaceConfigurationClient.getMasterData().pipe(
        tap((masterData: ExportInterfaceMasterDataDTO) => {
          this.masterData = masterData;
          this.lastLoadedTime = DateTime.now();
        })
      );
    }
    return of(this.masterData);
  }

  public getSourceFieldsForConfigurationType(configurationType: ExportInterfaceConfigurationType): ExportInterfaceFieldAssignmentSourceInfoDTO[] {
    let key = Object.values(ExportInterfaceConfigurationType)[configurationType]
    return this.allSourceFieldsDTO.allSourceFields[key];
  }

  public getAllSourceFields(): string[] {
    // get distinct string list of all source isreplaceable fields
    let allSourceFields: string[] = [];
    Object.keys(this.allSourceFieldsDTO.allSourceFields).forEach(key => {
      this.allSourceFieldsDTO.allSourceFields[key].forEach(sourceField => {
        if (sourceField.isValueReplaceable) {
          allSourceFields.push(sourceField.sourceName);
        }
      });
    });
    //remove duplicates from array
    allSourceFields = allSourceFields.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
    // return sorted array
    allSourceFields.sort();
    return allSourceFields;
  }
}
